import { Button } from "@mui/material";
import cls from "./LearnDashboardNavmenu.module.scss";
import { LearnCourseProgress } from "../../lib/LearnCourseProgress/LearnCourseProgress";
import { ButtonShare } from "../../../../shared/ui/ButtonShare/ButtonShare";
import { ButtonLike } from "../../../../shared/ui/ButtonLike/ButtonLike";
import logo from "../../../../logo.svg";
import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";

interface StudyDashboardNavMenuProps {
  courseInfo: any;
  setPassedPart: (passedPart: any) => void;
}

export const LearnDashboardNavmenu = ({
  courseInfo,
  setPassedPart,
}: StudyDashboardNavMenuProps) => {
  const navigate = useNavigate();
  const totalLessons = courseInfo.data.reduce(
    (sum: any, part: { items: string | any[] }) => sum + part.items.length,
    0
  );
  const countPassedParts = localStorage.getItem("passedPart")
    ? JSON.parse(localStorage.getItem("passedPart") ?? "")
    : [];

  const clearPassedParts = useCallback(() => {
    localStorage.removeItem("passedPart");
    setPassedPart([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={cls.studyDashboardNavMenu}>
      <img
        src={logo}
        className="logo"
        alt="logo"
        onClick={() => {
          navigate("/");
        }}
      />

      <span className={cls.dividerVertical} />

      <p>{courseInfo.name}</p>

      <div className={cls.right}>
        <Button onClick={clearPassedParts}>Очистить прогресс курса</Button>
        <LearnCourseProgress
          totalLessons={totalLessons}
          currentStep={countPassedParts.length}
          totalSteps={totalLessons}
        />

        <div className={cls.buttons}>
          <ButtonShare />
          <ButtonLike />
        </div>
      </div>
    </div>
  );
};
